import { api } from "@/lib/api";

export const CurriculumItemsAPI = {
  // List exam-structure sequences (with per-node item counts) visible to the user
  sequences: (params) => api.get("/curriculum/sequences", { params }).then((r) => r.data),
  sequence: (sid) => api.get(`/curriculum/sequences/${sid}`).then((r) => r.data),
  // Curriculum items (uploaded artefacts tied to one assessment node)
  items: (params) => api.get("/curriculum/items", { params }).then((r) => r.data),
  upload: (formData) =>
    api.post("/curriculum/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data),
  remove: (id) => api.delete(`/curriculum/items/${id}`).then((r) => r.data),
  fileUrl: (fileId) => `/api/v1/curriculum/files/${fileId}`,
};
